import { Controller } from "stimulus";

const STATUS_LABELS = {
  pending: { text: "Sedang Diproses", className: "label-warning" },
  finished: { text: "Selesai", className: "label-success" },
  failed: { text: "Gagal", className: "label-danger" },
};

export default class extends Controller {
  connect() {
    this.listUrl = this.data.get("listUrl");
    this.createUrl = this.data.get("createUrl");
    this.loadList();
  }

  disconnect() {
    this.stopPolling();
  }

  generate() {
    const button = this.element.querySelector('[data-role="generate-btn"]');
    if (button) button.disabled = true;

    fetch(this.createUrl, {
      method: "POST",
      headers: {
        "X-CSRF-Token": window.Util.getCsrfToken(),
        Accept: "application/json",
      },
    })
      .then((response) => response.json().then((body) => ({ response, body })))
      .then(({ response, body }) => {
        const icon = response.status === 202 ? "success" : "warning";
        window.Swal.fire({ icon: icon, text: body.message, timer: 4000 });
        this.loadList();
      })
      .catch(() => {
        window.Swal.fire({
          icon: "error",
          text: "Gagal membuat laporan. Silakan coba lagi.",
        });
      })
      .finally(() => {
        if (button) button.disabled = false;
      });
  }

  loadList() {
    fetch(this.listUrl, { headers: { Accept: "application/json" } })
      .then((response) => response.json())
      .then((body) => {
        this.render(body.reports || []);
        this.schedulePolling(body.reports || []);
      })
      .catch(() => {});
  }

  render(reports) {
    const list = this.element.querySelector('[data-role="list"]');
    if (!list) return;

    if (reports.length === 0) {
      list.innerHTML = '<li class="text-muted">Belum ada laporan dibuat.</li>';
      return;
    }

    list.innerHTML = reports.map((report) => this.row(report)).join("");
  }

  row(report) {
    const label = STATUS_LABELS[report.status] || STATUS_LABELS.pending;
    const badge = `<span class="label ${label.className} label-inline font-weight-bold ml-2">${label.text}</span>`;
    const message =
      report.status === "failed" && report.status_message
        ? ` <span class="text-muted">(${report.status_message})</span>`
        : "";
    const download =
      report.status === "finished" && report.download_path
        ? ` <a href="${report.download_path}" class="btn btn-sm btn-light-primary font-weight-bold ml-2" download><i class="fa fa-download mr-1"></i>Unduh PDF</a>`
        : "";

    return `<li class="d-flex align-items-center py-2 border-bottom"><i class="fa fa-file-pdf mr-2" style="color:#EE6123;"></i><span class="font-weight-bold">${report.created_at}</span>${badge}${message}${download}</li>`;
  }

  schedulePolling(reports) {
    const hasPending = reports.some((report) => report.status === "pending");
    if (hasPending) {
      if (!this.pollTimer)
        this.pollTimer = setInterval(() => this.loadList(), 5000);
    } else {
      this.stopPolling();
    }
  }

  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }
}
